import React, { useMemo } from "react";
import { linkifyHtml, sanitizeRichText } from "../../utils/richText";

type Props = {
  html?: string | null;
  className?: string;
  emptyFallback?: string;
  linkify?: boolean;
};

/** Read-only display of stored rich text: sanitized, with clickable links opening in a new tab. */
const RichTextView: React.FC<Props> = ({
  html,
  className,
  emptyFallback = "<p>No description added.</p>",
  linkify = true,
}) => {
  const content = useMemo(() => {
    const sanitized = sanitizeRichText(html || "");
    return linkify ? linkifyHtml(sanitized) : sanitized;
  }, [html, linkify]);

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: content || emptyFallback }}
    />
  );
};

export default RichTextView;
